import { UserObj } from '@Reducers/User/Type';

export function getAccountType(account: UserObj['_accountId'] | any) {
  const isIndividual = account?.accountType === 'individual';
  const isAccountHolder = Boolean(account?.isAccountHolder);
  return isAccountHolder ? (isIndividual ? 'account-individual' : 'account-individual-company') : 'individual';
}
